import { createContext, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  useEffect(() => {
    http.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
    const out = () => setUser(false);
    window.addEventListener("jarvis:logout", out);
    return () => window.removeEventListener("jarvis:logout", out);
  }, []);
  const login = async (email, password) => setUser((await http.post("/auth/login", { email, password })).data);
  const logout = async () => { await http.post("/auth/logout"); setUser(false); };
  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
